import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM8.5 8A1.5 1.5 0 1 1 10 9.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0v-.345A3.001 3.001 0 0 0 10 5a3 3 0 0 0-3 3 .75.75 0 0 0 1.5 0Zm2.25 5.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0v-.5Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgHelpFill);
export { ForwardRef as ReactComponent };
